// 검색 input 의 autocomplete(입력 기록) 공유 키 모음.
// 브라우저는 input 의 name + origin 기준으로 입력값을 기억하므로,
// 여러 페이지의 input 이 같은 name 을 쓰면 같은 입력 기록 드롭다운을 공유한다.
// 같은 키 = 같은 드롭다운. 페이지별로 문자열을 직접 박지 말고 항상 여기서 참조한다.
export const SEARCH_FIELD = {
  EXPORT_BL: 'exportBlSearchKeyword', // 수출 Booking/B/L No
  IMPORT_BL: 'importBlSearchKeyword', // 수입 B/L No
  FW_SR_NO: 'fwSrNoSearchKeyword', // FW S/R No (BL 아님)
  EXPORT_INVOICE: 'exportInvoiceSearchKeyword', // 수출 Invoice No
  IMPORT_INVOICE: 'importInvoiceSearchKeyword' // 수입 Invoice No
}

// 'E'(WorkingProgress) 또는 'O'(정산 화면) 이면 수출로 본다.
function isExport (eiCatCd) {
  return eiCatCd === 'E' || eiCatCd === 'O'
}

// 수출/수입 구분값을 받아 공유할 BL 검색 필드 name 을 반환한다.
export function blSearchFieldName (eiCatCd) {
  return isExport(eiCatCd) ? SEARCH_FIELD.EXPORT_BL : SEARCH_FIELD.IMPORT_BL
}

// 수출/수입 구분값을 받아 공유할 Invoice 검색 필드 name 을 반환한다.
export function invoiceSearchFieldName (eiCatCd) {
  return isExport(eiCatCd) ? SEARCH_FIELD.EXPORT_INVOICE : SEARCH_FIELD.IMPORT_INVOICE
}
